export default {
  getFilename(file) {
    const start = 0
    const end = file.name.lastIndexOf('.')

    return file.name.substring(start, end)
  },

  getExtension(file) {
    return file.name.split('.').pop()
  },

  getMimetype(file) {
    return file.type || null
  },

  parseFileForGraphql(file, path) {
    return {
      path: path,
      name: this.getFilename(file),
      extension: this.getExtension(file)
    }
  },

  parseFilesFromDropzoneForGraphql(dropzone, path) {
    return (dropzone || []).map((file) => ({
      path: path,
      name: file.name,
      extension: file.extension
    }))
  }
}
